
import React from 'react';
import { Row, Col, Container, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom'

import english from '../../../assets/images/features/feature13/English.jpg';
import hindi from '../../../assets/images/features/feature13/Hindi.jpg';
const Services = () => {
    return (
        <div>
            <div className="bg-light spacer feature20 up">
                <Container>
                <Row className="justify-content-center">
                        <Col md="7" className="text-center">
                            <h1 className="title font-bold">Services</h1>
                            <h6 className="subtitle">We offer services that meet your needs.</h6>
                        </Col>
                    </Row>
                    <Row className="wrap-feature-20">
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={english} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Convert a scanned image to text <b>English</b> </h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                    <Link to="/scanned-to-text-english" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={hindi} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Convert a scanned image to text <b>Hindi</b></h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <Link to="/scanned-to-text-hindi" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={english} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Converts an uploaded PDF file to text <b>English</b></h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                    <Link to="/pdf-to-text-english" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={hindi} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Converts an uploaded PDF file to text <b>Hindi</b></h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                    <Link to="/pdf-to-text-hindi" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={english} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Convert a photo of a doc to text <b>English    </b></h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                    <Link to="/photo-to-text-english" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg="6">
                            <Card>
                                <Row>
                                    <Col md="8">
                                        <CardBody className="d-flex no-block">
                                            <div className="m-r-20"><img src={hindi} width="70" className="rounded" alt="img" /></div>
                                            <div>
                                                <h5 className="font-medium">Convert a photo of a doc to text <b>Hindi</b></h5>
                                            </div>
                                        </CardBody>
                                    </Col>
                                    <Col md="4" className="text-center">
                                    <Link to="/photo-to-text-hindi" className="text-white linking bg-success-gradiant">Lets Try <i className="ti-arrow-right"></i></Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Services;
